import { createConsumer, logger } from '@rails/actioncable';
import * as Sentry from '@sentry/react';
import authHeader from 'services/auth-header';

const CABLE_URL = process.env.REACT_APP_CABLE_URL;

if (process.env.NODE_ENV === 'development') {
  logger.enabled = true;
}

let consumer = null;
let intentionalDisconnect = false;
let authFailureHandled = false;
let onUnauthorized = null;

export function getCableToken() {
  return authHeader().Authorization || null;
}

function cableUrl() {
  return `${CABLE_URL}?token=${encodeURIComponent(getCableToken() || '')}`;
}

export function getCable() {
  if (!CABLE_URL) {
    console.error('[cable] REACT_APP_CABLE_URL is not set; realtime is disabled.');
    return null;
  }

  if (!getCableToken()) return null;

  if (!consumer) {
    intentionalDisconnect = false;
    authFailureHandled = false;
    consumer = createConsumer(cableUrl);
  }

  return consumer;
}

export function disconnectCable() {
  if (!consumer) return;
  intentionalDisconnect = true;

  try {
    consumer.disconnect(); // closes with allowReconnect: false
  } catch (e) {
    // Socket may already be closed.
  }

  consumer = null;
}

export function setCableUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

export function handleCableDisconnect(payload) {
  if (payload?.willAttemptReconnect !== false) {
    // Ordinary blip; the library retries with backoff. Breadcrumb only, or every
    // mobile-network hiccup becomes a Sentry issue.
    Sentry.addBreadcrumb({ category: 'cable', message: 'disconnected', level: 'info' });
    return;
  }

  reportUnauthorized('cable connection unauthorized');
}

export function reportUnauthorized(reason) {
  if (intentionalDisconnect) return; // we closed it (logout)
  if (!getCableToken()) return;      // already logged out elsewhere
  if (authFailureHandled) return;

  authFailureHandled = true;
  disconnectCable();

  Sentry.captureMessage(reason);
  if (onUnauthorized) onUnauthorized();
}

export function reportRejectedSubscription(channelParams) {
  console.warn('[cable] subscription rejected', channelParams);
  Sentry.captureMessage('cable subscription rejected', { extra: { channelParams } });
}
